module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.params.view === 'dashboard') ? _c('dashboard', {
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": _vm.$route.params.addr
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.view === 'graph') ? _c('graph', {
    attrs: {
      "pollingTime": "30000",
      "polling": "true",
      "addr": _vm.$route.params.addr
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59089986","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vis.vue
// module id = 792
// module chunks = 1